module.exports = __webpack_public_path__ + "smoking.d4dccd08.mp4";